import React from "react";
import SectionHeading from "./SectionHeading";
import { EXPERIENCE, EXPERIENCE_INTRO } from "./data/content";
import { useIntersectionObserver } from "./useIntersectionObserver";

function Experience() {
  const ref = React.useRef(null);
  const [inView] = useIntersectionObserver(ref);

  return (
    <section
      id="experience"
      className={"site-section site-section--alt" + (inView ? " section-is-visible" : "")}
      ref={ref}
    >
      <div className="section-inner">
        <SectionHeading
          label="Experience"
          title="Where I've been building"
          description={EXPERIENCE_INTRO}
        />

        <ol className="timeline">
          {EXPERIENCE.map((item, index) => (
            <li
              key={item.id}
              className={
                "timeline-item reveal-item timeline-item--" +
                item.accent
              }
              style={{ "--item-index": index }}
            >
              <div className="timeline-marker" aria-hidden="true" />
              <article className="timeline-card glass-card">
                <div className="timeline-card-header">
                  <span className="timeline-period">{item.period}</span>
                  {item.note && (
                    <span className="timeline-note">{item.note}</span>
                  )}
                </div>
                <h3 className="timeline-role">{item.role}</h3>
                <p className="timeline-org">{item.org}</p>
                <p className="timeline-summary">{item.summary}</p>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default Experience;
